export default {
    authorizationType: null,
    isPreviousDateSession: false,
    previousDate: null,
    previousTime: null,
    previousDuration: null,
    user: null,
    clientId: null
};


// WEBPACK FOOTER //
// ./src/common/auth/vuex/state.js